import {
  Box,
  Button,
  CloseButton,
  Dialog,
  Portal,
  Text
} from '@chakra-ui/react';
import React from 'react';

interface IDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  onConfirm: () => void;
  isLoading?: boolean;
  cancelLabel?: string;
  confirmLabel?: string;
  message: string;
  colorPalette?: string;
}

const DeleteModal: React.FC<IDeleteModalProps> = ({
  isOpen,
  onClose,
  title,
  onConfirm,
  isLoading = false,
  cancelLabel = 'Cancel',
  confirmLabel = 'Delete',
  message,
  colorPalette = 'red',
}) => {
  return (
    <Dialog.Root placement="center" open={isOpen} onOpenChange={onClose}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header position="relative" px={6}>
              <Text
                fontSize={18}
                fontWeight={600}
                pt={6}
                pb={4}
                color="textPrimary"
              >
                {title}
              </Text>
              <CloseButton
                position="absolute"
                top={0}
                right={0}
                onClick={onClose}
              />
            </Dialog.Header>
            <Dialog.Body px={6}>
              <Box
                pt={2}
                pb={4}
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                gap="10px"
                alignSelf="stretch"
              >
                <Text color="fg.muted" fontSize={14} fontWeight={400}>
                  {message}
                </Text>
              </Box>
            </Dialog.Body>
            <Dialog.Footer gap={3} justifyContent="flex-end" pt={2} pb={4} px={6}>
              <Button
                variant="outline"
                onClick={onClose}
                px={4}
                py={2}
                m={0}
              >
                {cancelLabel}
              </Button>
              <Button
                colorPalette={colorPalette}
                color={colorPalette === 'red' ? 'red.contrast' : 'white'}
                onClick={onConfirm}
                loading={isLoading}
                loadingText="Deleting..."
                px={4}
                py={2}
                m={0}
              >
                {confirmLabel}
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default DeleteModal;
